export default __webpack_public_path__ + "f9ac6d611adc137c21ea933b0c1cca4b.svg";